import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { jsx as _jsx } from "react/jsx-runtime";
import React, { useContext, useLayoutEffect, useState } from 'react';
import { overlayZIndex } from '../../../foundations/zIndex.constants';
import { BottomSheetPageIdProvider } from '../../../providers/BottomSheetPageIdProvider';
import { OverlayContext } from '../../../providers/OverlayContextProvider';
import { BottomSheetContentLayout } from '../../BottomSheet/BottomSheetContentLayout/BottomSheetContentLayout';
import { SheetDrawer } from '../../BottomSheet/SheetDrawer/SheetDrawer';
import { ModalEntryContent } from '../ModalContainer/ModalContainer';
import { OverlayPopupZIndex } from '../OverlayPopupZIndex/OverlayPopupZIndex';
import { selectSheetChrome, selectSheetRunPages } from './BottomSheetContainer.utils';
import { useSheetRunPageLifecycle } from './hooks/useSheetRunPageLifecycle';
// WHY: a sheet page has no husk dialog to hide and no insets to own — the drawer is the surface.
const noopModalHost = {
    setDetached: ()=>{},
    setOwnsFullScreen: ()=>{}
};
const propsASheetPageNeverRegistersWith = {
    registerCanDismiss: ()=>{}
};
export function BottomSheetContainer(param) {
    let { entries, zIndexOrder, triggerClose, onModalExited } = param;
    const { isTestMode } = useContext(OverlayContext);
    const { openEntries, visibleEntry, renderedEntries } = selectSheetRunPages(entries);
    const chrome = selectSheetChrome(entries, visibleEntry);
    const { dismissPage, dismissEveryPage, settleEveryPageOnceTheDrawerHasSlidOut } = useSheetRunPageLifecycle({
        entries,
        openEntries,
        triggerClose,
        onModalExited
    });
    // WHY: MUI's Modal clears its `exited` flag from the enter transition only, so a drawer mounted already-open never reports onExited.
    const [drawerCanReportItsExit, setDrawerCanReportItsExit] = useState(false);
    useLayoutEffect(()=>setDrawerCanReportItsExit(true), []);
    const hostZIndex = overlayZIndex(zIndexOrder !== null && zIndexOrder !== void 0 ? zIndexOrder : 0);
    return /*#__PURE__*/ _jsx(SheetDrawer, _object_spread_props(_object_spread({
        open: drawerCanReportItsExit && openEntries.length > 0,
        zIndex: hostZIndex,
        isTestMode: isTestMode,
        showBackButton: openEntries.length > 1
    }, chrome), {
        onClose: dismissEveryPage,
        onBack: ()=>visibleEntry && dismissPage(visibleEntry)(),
        onExited: settleEveryPageOnceTheDrawerHasSlidOut,
        children: /*#__PURE__*/ _jsx(OverlayPopupZIndex, {
            hostZIndex: hostZIndex,
            children: renderedEntries.map((entry, index)=>{
                var _entry_sheetPage;
                const dismissModal = dismissPage(entry);
                entry.dismissModal = dismissModal;
                const body = /*#__PURE__*/ _jsx(ModalEntryContent, {
                    entry: entry,
                    modalProps: _object_spread({
                        dismissModal
                    }, propsASheetPageNeverRegistersWith),
                    modalHost: noopModalHost,
                    isInModal: false
                });
                return /*#__PURE__*/ _jsx("div", {
                    style: {
                        display: index === renderedEntries.length - 1 ? 'contents' : 'none'
                    },
                    children: /*#__PURE__*/ _jsx(BottomSheetPageIdProvider, {
                        value: entry.id,
                        children: ((_entry_sheetPage = entry.sheetPage) === null || _entry_sheetPage === void 0 ? void 0 : _entry_sheetPage.layout) != null ? /*#__PURE__*/ _jsx(BottomSheetContentLayout, _object_spread_props(_object_spread({}, entry.sheetPage.layout), {
                            children: body
                        })) : body
                    })
                }, entry.id);
            })
        })
    }));
}
